module.exports = __webpack_public_path__ + "img/风华高科.3e0aff40.jpg";